import icon from "../../assets/icon.svg";

const ClearheadCharacter = () => (
  <div className="bg-white shadow rounded-full w-16 h-16 flex justify-center items-center mb-4 mx-auto">
    <img src={icon} alt="Clearhead Icon" className="w-10 h-10" />
  </div>
);

export default ClearheadCharacter;
